const firebaseConfig = {
    apiKey: "AIzaSyDQwHp4-xNGxE7upUoPJIGcFlTTcxvdW1o",
    authDomain: "volunteer-networks-client.firebaseapp.com",
    databaseURL: "https://volunteer-networks-client.firebaseio.com",
    projectId: "volunteer-networks-client",
    storageBucket: "volunteer-networks-client.appspot.com",
    messagingSenderId: "280066719404",
    appId: "1:280066719404:web:264e14e47e8a9df5126909"
  };
  export default firebaseConfig;